import { RootState } from '../types'

export const getCustomerSelector = (state: RootState) => state.customers
